import { ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Dependencies } from '../../../../store';
import { pluck } from '../../../../store.decorator';
import { PayloadAction } from '../../../../store.model';
import { ChatStatusService } from '../../../../teams-call';
import { ActionType } from '../teamschat-dialog.action';
import { TeamschatDialogState } from '../teamschat-dialog.state';

import { DeleteMessages, deleteMessagesResult } from './delete-messages.action';

export const deleteMessagesEpic = (
    action: Observable<PayloadAction<ActionType, DeleteMessages>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<PayloadAction<ActionType, DeleteMessages>> =>
    action.pipe(
        ofType(ActionType.COACHING_DETAIL__TCD__DELETE_MESSAGES),
        mergeMap((act: PayloadAction<ActionType, DeleteMessages>) => {
            const rootState = pluck<TeamschatDialogState>(
                state.value,
                act.storePath,
            );
            const statusService =
                deps.injector.get<ChatStatusService>(ChatStatusService);

            return of(null).pipe(
                tap(() => {
                    // TODO batch
                    act.payload.messages.forEach((e) => {
                        void statusService.deleteMessage(
                            {
                                msftChatThreadId:
                                    rootState.chat.msftChatThreadId,
                            },
                            e,
                        );
                    });
                }),
                map(() => {
                    return deleteMessagesResult(
                        {
                            ...act.payload,
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
